import type { GetActionUpdatesByParentActionIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetActionUpdatesByParentActionIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActionUpdatesByParentActionIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetActionUpdatesByParentActionIdArgs = {
  parentActionId: string;
};

export const useLazyGetActionUpdatesByParentActionId = createLazyQueryHook<
  UseLazyGetActionUpdatesByParentActionIdArgs,
  GetActionUpdatesByParentActionIdResponseRow[],
  GetActionUpdatesByParentActionIdQuery
>({
  trpcQuery: (client, { parentActionId }) =>
    client.frontend.action.updates.getActionUpdatesByParentActionId.query({
      ParentActionId: parentActionId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ action_update: data }),
  graphqlDocument: GetActionUpdatesByParentActionIdDocument,
  graphqlVariables: ({ parentActionId }) => ({ _eq: parentActionId }),
});
